import { useEffect } from "react";
import {
  Box,
  Card,
  Flex,
  Text,
  Heading,
  Container,
  Spinner,
} from "@radix-ui/themes";
import { config } from "@/config/env";

export default function LoginPage() {
  useEffect(() => {
    // If nested inside an iframe, don't redirect the frame itself. Tell the parent to exit management.
    if (window.parent !== window.self) {
      window.parent.postMessage({ type: "exit-management" }, "*");
      return;
    }

    // Check for tokens in URL (from central auth redirect)
    const urlParams = new URLSearchParams(window.location.search);
    const accessToken = urlParams.get("access_token");
    const refreshToken = urlParams.get("refresh_token");

    if (accessToken && refreshToken) {
      // Tokens are present - the AuthProvider will handle them automatically
      // Just wait for the auth state to update
      return;
    }

    // No tokens, redirect to central auth immediately
    const redirectUri = encodeURIComponent(window.location.origin);
    window.location.href = `${config.centralAuthUrl}/auth/login?redirect_uri=${redirectUri}`;
  }, []);

  return (
    <Container
      size="1"
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "1rem",
      }}
    >
      <Card style={{ width: "100%", maxWidth: "28rem" }}>
        <Box p="6">
          <Flex direction="column" gap="6" align="center">
            <Heading size="7" weight="bold" align="center">
              Anythink Admin
            </Heading>
            <Spinner size="3" />
            <Text color="gray" align="center" size="3">
              {new URLSearchParams(window.location.search).get("access_token")
                ? "Authenticating..."
                : "Loading..."}
            </Text>
          </Flex>
        </Box>
      </Card>
    </Container>
  );
}
